import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, Typography } from "@material-ui/core";
import RestoreIcon from '@material-ui/icons/Restore';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';
import { TooltipTop as CustomTooltip } from "../../../Common/CustomTooltips";
import zoneIcon from "../../../../images/zoneIcon.png";
import styles from "./styles";
import t from "../../../../languages/pl";

const useStyles = makeStyles(theme => styles(theme, ({
    iconZone: {
    width: 24,
    height: 24,
} })));

const Zone = props => {
    const { startTime, finishTime, timeOutsideZone, distance } = props;
    const theme = useTheme();
    const classes = useStyles(theme);

    return (
        <React.Fragment>
            <div className={classes.location}>
                <CustomTooltip title={t.routeDuration}>
                    <RestoreIcon />
                </CustomTooltip>
                &nbsp;<Typography
                    variant="body2"
                >
                    {startTime} - {finishTime}
                </Typography>
            </div>
            <div className={classes.location}>
                <CustomTooltip title={t.timeOutsideTheZone}>
                    <img src={zoneIcon} alt="zone" className={classes.iconZone} />
                </CustomTooltip>
                &nbsp;
                <Typography
                    variant="body2"
                >
                    {t.outsizeZone}&nbsp;{timeOutsideZone}
                </Typography>
            </div>
            <div className={classes.location}>
                <CustomTooltip title={t.kilometerQuantityOutsizeZone}>
                    <SettingsEthernetIcon />
                </CustomTooltip>
                &nbsp;
                <Typography variant="body2">
                    {distance}&nbsp;km
                </Typography>
            </div>
        </React.Fragment>
    );
};

Zone.propTypes = {
    startTime: PropTypes.string,
    finishTime: PropTypes.string,
    timeOutsideZone: PropTypes.string,
    distance: PropTypes.number
};

export default Zone;
